import React from 'react';
import { t } from '../../utils/i18n';
import { GenericPaymentMethodItemCollapsed } from '../GenericPaymentMethodItemCollapsed';
import { InstallmentPaymentMethod } from '../../types/InstallmentPaymentMethod';
import { DH } from '../../utils/DataHook';
import { reverseMapSearch } from '../../utils/reverseMapSearch';
import { PaymentMethodsListProps } from './types';
import * as s from './styles.scss';

export const PaymentMethodsListViewCollapsed: React.FC<PaymentMethodsListProps> = ({
  paymentMethods,
  bnplMethods,
  deviceType,
  openModal,
}) => {
  const facingPaymentMethods = paymentMethods.slice(0, -1);
  const trailingPaymentMethod = paymentMethods.slice(-1)[0];
  const breakdownMessage = t('generic.view.breakdownMessage');
  const conjunction = t('generic.view.or');

  return (
    <div className={s.container} data-hook={DH.PaymentMethodView.CollapsedView}>
      {`${breakdownMessage} `}
      {facingPaymentMethods.map((paymentMethod, index) => (
        <React.Fragment key={paymentMethod}>
          <GenericPaymentMethodItemCollapsed
            /* Fetching payment method name from enum key names */
            paymentMethodName={
              reverseMapSearch(InstallmentPaymentMethod, paymentMethod) as unknown as InstallmentPaymentMethod
            }
            paymentMethod={paymentMethod}
            bnplPayload={bnplMethods.find((m) => m.paymentMethod === paymentMethod)}
            deviceType={deviceType}
            openModal={openModal}
          />
          {index < facingPaymentMethods.length - 1 ? ', ' : ''}
        </React.Fragment>
      ))}
      {` ${conjunction} `}
      <GenericPaymentMethodItemCollapsed
        paymentMethodName={
          reverseMapSearch(InstallmentPaymentMethod, trailingPaymentMethod) as unknown as InstallmentPaymentMethod
        }
        paymentMethod={trailingPaymentMethod}
        bnplPayload={bnplMethods.find((m) => m.paymentMethod === trailingPaymentMethod)}
        deviceType={deviceType}
        openModal={openModal}
      />
    </div>
  );
};
PaymentMethodsListViewCollapsed.displayName = 'PaymentMethodsListViewCollapsed';
